export const OPEN_EULA_PROMPT = 'EULA_OPEN_EULA_PROMPT'
export const OPEN_ON_FETCH = 'EULA_OPEN_ON_FETCH'
export const ACCEPT_EULA = 'EULA_ACCEPT_EULA'
export const DECLINE_EULA = 'EULA_DECLINE_EULA'
export const SET_BUTTON_TEXTS = 'EULA_SET_BUTTON_TEXTS'



// WEBPACK FOOTER //
// ./src/features/Eula/data/prompt/constants.js